import api from './api'

// Google Merchant Center service
export const googleMerchantService = {
  // Bulk update all products to Google Merchant Center
  bulkUpdateProducts: async () => {
    const response = await api.post('/google-merchant/products/bulk-update')
    return response
  },

  // Update product in Google Merchant Center
  updateProduct: async (productData) => {
    const response = await api.post('/google-merchant/products/update', productData)
    return response
  },

  // Delete product from Google Merchant Center
  deleteProduct: async (productId) => {
    const response = await api.delete(`/google-merchant/products/${productId}`)
    return response
  },

  // Get product from Google Merchant Center
  getProduct: async (productId) => {
    const response = await api.get(`/google-merchant/products/${productId}`)
    return response
  },

  // List all products from Google Merchant Center
  listProducts: async (params = {}) => {
    const response = await api.get('/google-merchant/products', { params })
    return response
  },

  // Test Google Merchant Center connection
  testConnection: async () => {
    const response = await api.get('/google-merchant/test-connection')
    return response
  }
}

export default googleMerchantService
